export const defaultLocale = "fr";

const MESSAGES = {
  fr: {
    'restaurants-selected': '%s restaurants sélectionnées',
    'view-more': 'En voir plus',
    'choose-restaurants' : 'Choisir un ou plusieurs restaurants'
  },
  en: {
    'restaurants-selected': '%s restaurants selected',
    'view-more': 'View more',
    'choose-restaurants' : 'Select one or more restaurants'
  }
};

export const getLanguage = () => (typeof MILL3WP.language !== "undefined" ? MILL3WP.language : defaultLocale);
export const getLocale = () => (typeof MILL3WP.locale !== "undefined" ? MILL3WP.locale : defaultLocale);

export const getMessage = (ID) => {
  const language = getLanguage();
  const messagesForLocale = MESSAGES[language] !== undefined ? MESSAGES[language] : null;

  // if no messages for locale, return ID
  if( !messagesForLocale ) return ID;

  // return found message for current locale, or ID if not found
  return messagesForLocale[ID] !== undefined ? messagesForLocale[ID] : ID;
};

export default getMessage;
